/**
 * PATH: apps/quote/src/pages/claims/claim-editor-page/ClaimPermissionDenied.tsx
 * FILE_ID: QUOTE-CLAIMS-G10-PERMISSION-001
 * PURPOSE: Distinguish denied financial-document access from load failure.
 */
import { LockKeyhole } from 'lucide-react'
import { Link } from 'react-router-dom'

export function ClaimPermissionDenied() {
  return (
    <div role="alert" className="flex min-h-96 flex-col items-center justify-center px-6 text-center text-amber-800">
      <LockKeyhole className="h-10 w-10" />
      <h1 className="mt-3 text-lg font-semibold">Claim access is restricted</h1>
      <p className="mt-1 max-w-md text-sm">Your role does not have access to this job’s financial documents. Ask an organisation administrator or project owner for access.</p>
      <Link to="/claims" className="mt-4 min-h-11 rounded-lg border border-amber-300 px-4 py-2.5 text-sm font-medium">Back to claims</Link>
    </div>
  )
}
